import React, { useState } from 'react';
import styles from './styles.module.scss';

import { ReactComponent as Checked } from '../../../assets/icons/icon-box-checked.svg';
import { ReactComponent as Unchecked } from '../../../assets/icons/icon-box-unchecked.svg';

const Checkbox = ({ title, link, url, error, required, validate }) => {
  const [check, setCheck] = useState(false);
  const isError = error !== undefined;
  const handleChange = () => {
    setCheck(!check);
  };
  if (check) {
    validate(true);
  } else {
    validate(false);
  }
  return (
    <div className={styles.container}>
      <label>
        <input
          type="checkbox"
          onChange={handleChange}
          required={required}
          checked
        />
        {check ? <Checked /> : <Unchecked />}
        <p className={isError ? styles.error : ''}>
          <span>{title} </span>
          {link && url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {link}
            </a>
          ) : (
            ''
          )}
        </p>
      </label>
    </div>
  );
};

export default Checkbox;
